import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { DisabledPayment } from './components/DisabledPayment/DisabledPayment';
import { CreditCardPayment } from './components/CreditCardPayment/CreditCardPayment';
import { AchPayment } from './components/AchPayment/AchPayment';
import { PaymentMethod } from '../../types';
import { Select } from '../../../CommonComponents/OPL/Select/Select/Select';
import { paymentMethodSelector, setPaymentMethod } from '../../state';
import { usePaymentQuery } from '../../api/usePaymentQuery';

const options = [
  { label: 'Disabled', value: PaymentMethod.Disabled },
  { label: 'Credit Card', value: PaymentMethod.CreditCard },
  { label: 'ACH', value: PaymentMethod.Ach },
];

export const PaymentForm: React.FC = () => {
  const paymentMethod = useSelector(paymentMethodSelector);

  const { data } = usePaymentQuery();

  const dispatch = useDispatch();

  if (!data) {
    return null;
  }

  const { paymentOptions } = data;

  return (
    <>
      <Box px="24">
        <Select
          label="Payment Method"
          value={options.find(opt => opt.value === paymentMethod)}
          options={options.filter(opt => ['Disabled', ...paymentOptions].includes(opt.value))}
          onChange={opt => {
            if (opt) {
              dispatch(setPaymentMethod(opt.value));
            }
          }}
          menuPortalTarget={document.body}
        />
      </Box>

      {paymentMethod === PaymentMethod.Disabled && <DisabledPayment />}

      {paymentMethod === PaymentMethod.CreditCard && <CreditCardPayment />}

      {paymentMethod === PaymentMethod.Ach && <AchPayment />}
    </>
  );
};
